// noinspection JSUnusedGlobalSymbols
/**
 * Contains static, baked-in configuration values.
 * Placeholders are substituted at build time from appconfig.json and package.json
 */
export class AppModuleConstants {

    /**
     * Core App Version (from package.json)
     */
    public static readonly VERSION = "0.0.0";
}



// WEBPACK FOOTER //
// ./src/app/app.module.constants.ts